document.addEventListener('DOMContentLoaded', () => {
  // Category tab filter (desktop/tablet: hide non-matching cards in the grid)
  // (mobile: the grid is a swipeable carousel instead, so tabs jump to a card
  // and the active tab syncs to whichever card is swiped into view — see below)
  const pfTabs = document.querySelectorAll('.pf-tab');
  const pfCards = document.querySelectorAll('.pf-card');
  const pfGrid = document.querySelector('.pf-grid');
  const pfMobileQuery = window.matchMedia('(max-width: 600px)');
  const isPfMobile = () => pfMobileQuery.matches;

  pfTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      pfTabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      const filter = tab.dataset.filter;

      if (isPfMobile() && pfGrid) {
        const target = filter === 'all'
          ? pfCards[0]
          : Array.from(pfCards).find((c) => c.dataset.group === filter);
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } else {
        pfCards.forEach((card) => {
          const match = filter === 'all' || card.dataset.group === filter;
          card.classList.toggle('pf-hidden', !match);
        });
      }
    });
  });

  // Keep the active tab synced to whichever card is centered while swiping (mobile only)
  if (pfGrid) {
    let pfScrollTimer = null;
    pfGrid.addEventListener('scroll', () => {
      if (!isPfMobile()) return;
      clearTimeout(pfScrollTimer);
      pfScrollTimer = setTimeout(() => {
        const trackRect = pfGrid.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let closest = null;
        let closestDist = Infinity;
        pfCards.forEach((card) => {
          const r = card.getBoundingClientRect();
          const dist = Math.abs(r.left + r.width / 2 - center);
          if (dist < closestDist) { closestDist = dist; closest = card; }
        });
        if (closest) {
          const group = closest.dataset.group;
          pfTabs.forEach((t) => t.classList.toggle('active', t.dataset.filter === group));
        }
      }, 100);
    }, { passive: true });

    // Switching from mobile carousel back to desktop/tablet grid: make sure
    // no card is left hidden from a stale mobile-era filter click.
    pfMobileQuery.addEventListener('change', (e) => {
      if (!e.matches) {
        pfCards.forEach((card) => card.classList.remove('pf-hidden'));
      }
    });
  }

  // FAQ accordion (single-open)
  const faqItems = document.querySelectorAll('.faq-item');
  const setAnswerHeight = (item, open) => {
    const answer = item.querySelector('.faq-answer');
    answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0px';
  };
  faqItems.forEach((item) => setAnswerHeight(item, item.classList.contains('open')));
  faqItems.forEach((item) => {
    item.querySelector('.faq-question').addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      faqItems.forEach((i) => { i.classList.remove('open'); setAnswerHeight(i, false); });
      if (!isOpen) { item.classList.add('open'); setAnswerHeight(item, true); }
    });
  });

  // Hero 3D fanned guide carousel
  const heroStage = document.getElementById('heroFanStage');
  const heroPrev = document.getElementById('heroFanPrev');
  const heroNext = document.getElementById('heroFanNext');
  if (heroStage && heroPrev && heroNext) {
    const heroItems = Array.from(heroStage.querySelectorAll('.hero-fan-item'));
    let heroActive = 0;

    const renderHeroFan = () => {
      const count = heroItems.length;
      const itemWidth = heroItems[0].getBoundingClientRect().width || 230;
      const step = itemWidth * 0.62;

      heroItems.forEach((item, i) => {
        let offset = i - heroActive;
        if (offset > count / 2) offset -= count;
        if (offset < -count / 2) offset -= -count;
        const abs = Math.abs(offset);
        let transform = '';
        let opacity = 1;
        let zIndex = 10 - abs;
        let pointerEvents = 'auto';

        if (abs === 0) {
          transform = 'translate(-50%, -50%) translateX(0) scale(1) rotateY(0deg)';
        } else if (abs <= 2) {
          const dir = offset > 0 ? 1 : -1;
          transform = `translate(-50%, -50%) translateX(${dir * (step + (abs - 1) * step * 0.65)}px) scale(${1 - abs * 0.18}) rotateY(${dir * -22}deg)`;
          opacity = abs === 1 ? 0.85 : 0.55;
        } else {
          opacity = 0;
          pointerEvents = 'none';
          transform = 'translate(-50%, -50%) translateX(0) scale(0.6)';
        }

        item.style.transform = transform;
        item.style.opacity = opacity;
        item.style.zIndex = zIndex;
        item.style.pointerEvents = pointerEvents;
      });
    };

    heroPrev.addEventListener('click', () => {
      heroActive = (heroActive - 1 + heroItems.length) % heroItems.length;
      renderHeroFan();
    });
    heroNext.addEventListener('click', () => {
      heroActive = (heroActive + 1) % heroItems.length;
      renderHeroFan();
    });

    let heroResizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(heroResizeTimer);
      heroResizeTimer = setTimeout(renderHeroFan, 150);
    });

    renderHeroFan();
  }

  // Reusable swipeable-carousel component (mobile horizontal card carousels).
  // Native scroll-snap handles the touch/swipe itself; this just builds and
  // syncs the pagination dots. Call again for any future card section by
  // passing its track/dots/item selectors.
  function initSwipeCarousel(trackSelector, dotsSelector, itemSelector) {
    const track = document.querySelector(trackSelector);
    const dotsWrap = document.querySelector(dotsSelector);
    if (!track || !dotsWrap) return;

    const visibleItems = () => Array.from(track.querySelectorAll(itemSelector))
      .filter((el) => getComputedStyle(el).display !== 'none');

    const updateActiveDot = () => {
      const items = visibleItems();
      const dots = Array.from(dotsWrap.children);
      if (!items.length || !dots.length) return;
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let closestDist = Infinity;
      items.forEach((item, i) => {
        const r = item.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === closest));
    };

    const buildDots = () => {
      const items = visibleItems();
      dotsWrap.innerHTML = '';
      items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wkm-hcarousel-dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${items.length}`);
        dot.addEventListener('click', () => {
          item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
      updateActiveDot();
    };

    track.setAttribute('tabindex', '0');

    let scrollTimer = null;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    }, { passive: true });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 150);
    });

    const observer = new MutationObserver(() => buildDots());
    observer.observe(track, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });

    buildDots();
  }

  initSwipeCarousel('.pf-grid', '[data-carousel-dots="pf"]', '.pf-card');
  initSwipeCarousel('.stories-grid', '[data-carousel-dots="stories"]', '.story-card');
  initSwipeCarousel('.reviews-cards-row', '[data-carousel-dots="reviews"]', '.review-card-light');

  // Stories show more/fewer
  const storiesShowMoreBtn = document.getElementById('storiesShowMoreBtn');
  const storyExtraCards = document.querySelectorAll('.story-card-extra');
  if (storiesShowMoreBtn) {
    storiesShowMoreBtn.addEventListener('click', () => {
      const expanded = storiesShowMoreBtn.dataset.expanded === 'true';
      storyExtraCards.forEach((card) => card.classList.toggle('story-card-visible', !expanded));
      storiesShowMoreBtn.dataset.expanded = String(!expanded);
      storiesShowMoreBtn.textContent = expanded ? 'Show More Reviews' : 'Show Fewer Reviews';
    });
  }
});
